import { useApi } from '@mainstage/core-plugin-api';
import { useMutation } from '@tanstack/react-query';
import { customAlertApiRef, infoApiRef } from '../apis';

export function useEditPlatformModuleOverride() {
  const infoApi = useApi(infoApiRef);
  const alertApi = useApi(customAlertApiRef);

  return useMutation({
    mutationFn: infoApi.setModulesOverride.bind(infoApi),
    onError: e => {
      alertApi.post({
        severity: 'error',
        message: (e instanceof Error ? e : new Error('Something went wrong'))
          .message,
      });
    },
  });
}
